
import { defineComponent, onMounted, Ref, ref, watch } from "vue";
import { formatTime } from "../exercise/exercise_helpers";
import { useStore } from "vuex";
import { dispatchError } from "../../utils/error_handling";
export default defineComponent({
  name: "TimeFormatter",
  emits: ["timeExpired"],
  setup(_, { emit }) {
    const counter = ref(0);
    const store = useStore();

    const timer: Ref<HTMLDivElement | null> = ref(null);
    let interval;
    onMounted(async () => {
      try {
        updateTimer();
        startCounterRoutine();
      } catch (e) {
        console.error("[onMounted] Error ", e);
        await dispatchError(e);
      }
    });

    const updateTimer = () => {
      let remainingTimeMilliseconds =
        store.getters["content_module/exercise/remainingTime"];
      const remainingTimeSeconds = Math.round(remainingTimeMilliseconds / 1000);

      if (remainingTimeSeconds <= 0) {
        remainingTimeMilliseconds = 0;
        emit("timeExpired");
        clearInterval(interval);
      }

      const timer = getTimerElement();
      timer.innerText = formatTime(remainingTimeMilliseconds);

      const maximumTime = store.getters["content_module/exercise/maximumTime"];
      if (!maximumTime) {
        return;
      }

      let redLine = maximumTime * 10 / 100;
      if (redLine < 0) {
        redLine*= 10;
      }

      if (remainingTimeSeconds <= redLine) {
        timer.classList.add("red");
      }
    };

    const getTimerElement = (): HTMLDivElement => {
      if (!timer.value) {
        throw new Error("timer.value is null");
      }
      return timer.value;
    };

    const startCounterRoutine = () => {
      interval = setInterval(() => {
        counter.value++;
      }, 1000);
    };

    watch(counter, updateTimer);

    return {
      timer,
      counter,
    };
  },
});
